import { createFileRoute } from "@tanstack/react-router";
import { CityPicker } from "@/components/CityPicker";
import { SITE_URL } from "@/lib/seo";

export const Route = createFileRoute("/pakistan/cities")({
  head: () => ({
    meta: [
      { title: "Gold Rate by City — Pakistan | DrHint" },
      { name: "description", content: "Choose your city to see today's live 24K, 22K & 21K gold rate in Pakistan — Karachi, Lahore, Islamabad and every major city." },
      { property: "og:title", content: "Gold Rate by City — Pakistan" },
      { property: "og:description", content: "Pick your city and see live gold prices, charts, and full breakdown." },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/pakistan/cities` }],
  }),
  component: () => <CityPicker country="pakistan" metal="gold" />,
});